import _ from 'lodash';
import { useEffect, useState } from 'react';

export const useInput = (defaultValue) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  // If the default value is a number (indicating that this is an input field
  // that deals in numbers), we should cast all changed values to numbers.
  const cast = typeof defaultValue === 'number' ? _.toNumber : _.identity;
  const props = {
    value,
    onChange: (event) => setValue(cast(event.target.value)),
  };

  return [props, value, setValue];
};
